import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap';
import * as yup from 'yup';
import { Formik } from 'formik';
import AuthContext from '../../../auth/Context/AuthContext';
import axios from '../../../adapters/API/axios';
import Swal from 'sweetalert2';
import instance from '../../../adapters/API/axios';
import Select from 'react-select';

const schema = yup.object().shape({
    email: yup.string().required('Email di butuhkan!'),
    phone: yup
        .string()
        .required('No. Telepon di butuhkan!')
        .matches(/^[0-9]+$/, 'No. Telepon harus berupa angka'),
    nik: yup.string().max(16, 'NIK tidak boleh lebih dari 16 karakter!'),
});


function ModalEditKaryawan({
    showEditKaryawan,
    setShowEditKaryawan,
    fetchListUser,
    selectedEmployee
}) {
    const { tokens } = useContext(AuthContext);
    const tokenUser = tokens?.token;
    const [userDetail, setUserDetail] = useState();
    const [employeeDetail, setEmployeeDetail] = useState();
    const [disabled, setDisabled] = useState(false);
    const [imagePerson, setImagePerson] = useState(null);
    // const [listGroup, setListGroup] = useState([]);
    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        if (selectedImage) {
            if (selectedImage.size < 5000000) {
                setImagePerson(selectedImage);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Warning!',
                    text: 'Gambar tidak boleh lebih dari 5Mb',
                })
            }
        }

    };

    // console.log(selectedEmployee)

    const fetchUserDetail = () => {
        axios.get(`api/users/${selectedEmployee?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                setUserDetail(res.data);
                // console.log( res.data )
            }).catch(err => {
                // console.log( err )
                setUserDetail();
            })
    };
    useEffect(() => {
        if (selectedEmployee?.id != null) fetchUserDetail()
    }, [selectedEmployee?.id]);


    const fetchEmployeeDetail = () => {
        axios.get(`api/employee_detail/${selectedEmployee?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                setEmployeeDetail(res.data);
                // console.log( res.data )
            }).catch(err => {
                // console.log( err )
                setEmployeeDetail();
            })
    };
    useEffect(() => {
        if (selectedEmployee?.id != null) fetchEmployeeDetail()
    }, [selectedEmployee?.id]);


    // const fetchListGroup = () => {
    //     axios.get(`/api/groups/`,
    //         {
    //             headers:
    //             {
    //                 'Access-Control-Allow-Origin': '*',
    //                 'Content-Type': 'application/json',
    //                 withCredentials: true,
    //                 Authorization: `Token ` + tokenUser,
    //             },

    //         })
    //         .then(res => {
    //             let filteredArray = res.data.filter(item => item.name !== 'superuser');
    //             setListGroup(filteredArray);
    //             // console.log( res.data )
    //         }).catch(err => {

    //             console.log(err)
    //         })
    // };

    // useEffect(() => {
    //     if (tokenUser !== undefined) fetchListGroup()
    // }, [tokenUser]);


    const handleCloseEditKaryawan = () => {
        setShowEditKaryawan(false);
        setUserDetail();
        setEmployeeDetail();
        fetchUserDetail();
        fetchEmployeeDetail();
    };

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleDateChange = (e, setFieldValue) => {
        const inputDate = e.target.value;

        const currentDate = new Date();
        const selectedDate = new Date(inputDate);

        if (selectedDate > currentDate) {
            Swal.fire({
                icon: 'error',
                title: 'Warning!',
                text: 'Tanggal bergabung tidak bisa lebih dari hari ini!',
            });
            setFieldValue('date_joined', '');
        } else {
            setFieldValue('date_joined', inputDate);
        }
    };

    const defaultValue = {
        email: userDetail?.email || '',
        first_name: userDetail?.first_name || '',
        last_name: userDetail?.last_name || '',
        // groupId: userDetail?.groups[0].id || "",
        phone: employeeDetail?.phone || '',
        nik: employeeDetail?.nik || '',
        date_joined: employeeDetail?.date_joined || '',
    }

    // console.log(listGroup)

    // const [selectedDivisi, setSelectedDivisi] = useState(null);

    // const divisiOptions = useMemo(() =>
    //     listGroup.map(divisi => ({
    //         value: divisi.id,
    //         label: divisi.name,
    //     })), [listGroup]);


    // // Reset selectedDivisi setiap buka modal atau user ganti
    // useEffect(() => {
    //     if (showEditKaryawan) {
    //         setSelectedDivisi(null);
    //     }
    // }, [showEditKaryawan, userDetail]);

    // // Set default selectedDivisi berdasarkan userDetail dan listGroup
    // useEffect(() => {
    //     if (!showEditKaryawan) return;
    //     if (!userDetail?.groups?.length) return;
    //     if (selectedDivisi) return;
    //     if (!listGroup.length) return;

    //     const groupId = userDetail.groups[0].id;
    //     const defaultSelected = listGroup.find(group => group.id === groupId);

    //     if (defaultSelected) {
    //         setSelectedDivisi({
    //             value: defaultSelected.id,
    //             label: defaultSelected.name
    //         });
    //     }
    // }, [showEditKaryawan, userDetail, listGroup, selectedDivisi]);

    // const handleSelectDivisi = (selectedOption, setFieldValue) => {
    //     setSelectedDivisi(selectedOption);
    //     setFieldValue('groups.id', selectedOption ? selectedOption.value : null);
    // };

    // console.log(userDetail)

    const handleEditKaryawan = async (values) => {
        setDisabled(true);
        // console.log( values )
        if (!employeeDetail) {
            const finalDataPost = {
                ...values,
                user: selectedEmployee?.id,
                picture: imagePerson,
            };
            const finalDataPost2 = {
                ...values,
                user: selectedEmployee?.id,
            }

            try {
                const responsePost = await axios.post(`api/employee/`,
                    imagePerson ? finalDataPost : finalDataPost2,
                    {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'multipart/form-data',
                            withCredentials: true,
                            Authorization: `Token ` + tokenUser,
                        },
                    }
                );

                fetchListUser();
                handleCloseEditKaryawan();
                Swal.fire({
                    icon: 'success',
                    title: 'Karyawan berhasil di Ubah!',
                    showConfirmButton: false,
                    timer: 2000
                })
                setDisabled(false);
            } catch (err) {
                console.log(err)
                Swal.fire({
                    icon: 'warning',
                    title: 'Terjadi kesalahan saat mengubah karyawan!',
                    showConfirmButton: false,
                    timer: 2000
                })
                setDisabled(false);
            }
        } else if (employeeDetail) {
            const finalDataPatch = {
                ...values,
                picture: imagePerson,
            };
            const finalDataPatch2 = {
                ...values,
            };
            const finalDataPatch3 = {
                email: values?.email,
                first_name: values?.first_name,
                last_name: values?.last_name,
                // groups: [values?.groupId]
            }

            try {
                const responsePatch = await axios.patch(`api/employee_detail/${selectedEmployee?.id}`,
                    imagePerson ? finalDataPatch : finalDataPatch2,
                    {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'multipart/form-data',
                            withCredentials: true,
                            Authorization: `Token ` + tokenUser,
                        },
                    }
                );

                const responsePatchUsers = await axios.patch(`api/users/${selectedEmployee?.id}`,
                    finalDataPatch3,
                    {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'multipart/form-data',
                            withCredentials: true,
                            Authorization: `Token ` + tokenUser,
                        },
                    }
                );

                fetchListUser();
                handleCloseEditKaryawan();
                Swal.fire({
                    icon: 'success',
                    title: 'Karyawan berhasil di Ubah!',
                    showConfirmButton: false,
                    timer: 2000
                })
                setDisabled(false);
            } catch (err) {
                console.log(err)
                Swal.fire({
                    icon: 'warning',
                    title: 'Terjadi kesalahan saat mengubah karyawan!',
                    showConfirmButton: false,
                    timer: 2000
                })
                setDisabled(false);
            }
        }
    }


    return (
        <Modal
            show={showEditKaryawan}
            onHide={handleCloseEditKaryawan}
            backdrop="static"
            keyboard={false}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ fontFamily: 'Poppins-Medium' }}>
                    Ubah Karyawan {selectedEmployee?.first_name} {selectedEmployee?.last_name}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={defaultValue}
                    enableReinitialize={true}
                    validationSchema={schema}
                    onSubmit={handleEditKaryawan}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        setFieldValue
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='image'>Foto</Form.Label>
                                <Form.Control
                                    id='image'
                                    type="file"
                                    accept='image/png, image/jpeg'
                                    onChange={handleImageChange}
                                    style={{ color: '#222', fontFamily: 'Poppins-Regular', }}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='email'>Email</Form.Label>
                                <Form.Control
                                    id='email'
                                    type="email"
                                    value={values.email}
                                    onChange={handleChange}
                                    isInvalid={!!errors.email}
                                    required
                                    placeholder="Masukkan Email"
                                    style={{ color: '#363636', fontFamily: 'Poppins-Regular', minHeight: '50px' }}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.email}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='first_name'>Nama Depan*</Form.Label>
                                <Form.Control
                                    id='first_name'
                                    type="text"
                                    value={values.first_name}
                                    onChange={handleChange}
                                    required
                                    placeholder="Masukkan Nama Depan"
                                    style={{ color: '#363636', fontFamily: 'Poppins-Regular', minHeight: '50px' }}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='last_name'>Nama Belakang*</Form.Label>
                                <Form.Control
                                    id='last_name'
                                    type="text"
                                    value={values.last_name}
                                    onChange={handleChange}
                                    required
                                    placeholder="Masukkan Nama Belakang"
                                    style={{ color: '#363636', fontFamily: 'Poppins-Regular', minHeight: '50px' }}
                                />
                            </Form.Group>
                            {/* <Form.Group className='mb-3'>
                                <Form.Label style={formStyles.label} htmlFor='group'>Divisi*</Form.Label>
                                <Select
                                    id='group'
                                    options={divisiOptions}
                                    required
                                    value={selectedDivisi || null}
                                    onChange={option => handleSelectDivisi(option, setFieldValue)}
                                    styles={selectStyles}
                                />
                            </Form.Group> */}
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='nik'>NIK</Form.Label>
                                <Form.Control
                                    id='nik'
                                    type="text"
                                    value={values.nik}
                                    onChange={handleChange}
                                    isInvalid={!!errors.nik}
                                    required
                                    placeholder="Masukkan NIK"
                                    style={{ color: '#363636', fontFamily: 'Poppins-Regular', minHeight: '50px' }}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.nik}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label style={{ fontFamily: 'Poppins-Medium' }} htmlFor='tanggalJoin'>Tanggal Bergabung</Form.Label>
                                <Form.Control
                                    id='tanggalJoin'
                                    type='date'
                                    required
                                    max={getTodayDate()}
                                    onChange={(e) => handleDateChange(e, setFieldValue)}
                                    value={values.date_joined}
                                    style={{ color: '#222', fontFamily: 'Poppins-Regular', minHeight: '50px' }}
                                />
                            </Form.Group>
                            <Form.Group className="mb-4">
                                <Form.Label style={formStyles.label} htmlFor='phone'>No. Telp*</Form.Label>
                                <Form.Control
                                    id='phone'
                                    type="text"
                                    value={values.phone}
                                    onChange={handleChange}
                                    isInvalid={!!errors.phone}
                                    required
                                    placeholder="Masukkan No. Telepon"
                                    style={formStyles.input}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.phone}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <div className="d-grid gap-2">
                                <Button
                                    variant="btn"
                                    disabled={disabled}
                                    type='submit'
                                    style={{ backgroundColor: '#12B3ED', color: 'white', fontFamily: 'Poppins-Regular' }}>
                                    Simpan
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default ModalEditKaryawan


const formStyles = {
    label: {
        fontFamily: 'Poppins-Medium',
        color: '#222',
    },
    input: {
        color: '#222',
        fontFamily: 'Poppins-Regular',
        minHeight: '50px',
        borderColor: '#ced4da', // Initial border color
    },
};

const selectStyles = {
    control: (provided, state) => ({
        ...provided,
        minHeight: '50px', // Adjust the height as needed
        border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
        boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
        '&:hover': {
            borderColor: '#80bdff',
        },
        fontFamily: 'Poppins-Regular'
    }),
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? '#fff' : '#333',
        background: state.isSelected ? '#007bff' : '#fff',
        fontFamily: 'Poppins-Regular'
    }),
};



